import type { TPlanCard } from "@organisms/PlanCard/types";
import type { TAllPlanProps } from "../types";

export const plansB2C: TPlanCard[] = [
  {
    title: "Grátis",
    isMostPopular: false,
    description:
      "Profissionais e equipes que desejam experimentar a plataforma sem risco",
    value: "0",
    creditsPerMonth: "50",
    findEnterprise: "1 empresa encontrada = 1 crédito",
    buttonProps: {
      text: "Começar agora",
      link: "https://www.google.com.br",
    },
    moreBenefits: [
      "1 usuário",
      "Consulta, Prospecção e Enriquecimento com 50 créditos válidos por 30 dias",
      "Tutoriais em vídeo e base de conhecimento completa",
      "Autoatendimento: tire dúvidas na base de conhecimento a qualquer hora",
      "Suporte por ticket liberado quando fizer upgrade",
    ],
    variant: "lightBlueButton",
  },
  {
    title: "Start",
    isMostPopular: false,
    description:
      "Pequenas empresas e autônomos que precisam de fluxo constante de leads",
    value: "299",
    creditsPerMonth: "500",
    findEnterprise: "1 empresa encontrada = 1 crédito",
    buttonProps: {
      text: "Começar agora",
      link: "https://www.google.com.br",
    },
    initialBenefits: "Tudo do plano Grátis",
    moreBenefits: [
      "1 usuário",
      "Funcionalidades essenciais de busca e exportação",
      "Chat em horário comercial (SLA de 12 h)",
      "Tutoriais guiados para começar em menos de 15 min",
    ],
    variant: "darkBlueButton",
  },
  {
    title: "Flex",
    isMostPopular: false,
    description: "Times comerciais em expansão que buscam escalar a prospecção",
    value: "699",
    creditsPerMonth: "2.000",
    findEnterprise: "1 empresa encontrada = 1 crédito",
    buttonProps: {
      text: "Começar agora",
      link: "https://www.google.com.br",
    },
    initialBenefits: "Tudo do plano Start",
    moreBenefits: [
      "Filtros avançados, exportação em lote",
      "Créditos válidos por 60 dias",
      "Chat + e-mail com SLA de 8h",
      "Sessão de onboarding ao vivo para a equipe",
    ],
    variant: "darkBlueButton",
  },
  {
    title: "Full",
    isMostPopular: true,
    description: "Departamentos de Vendas e Marketing de médio porte",
    value: "1.299",
    creditsPerMonth: "5.000",
    findEnterprise: "1 empresa encontrada = 1 crédito",
    buttonProps: {
      text: "Começar agora",
      link: "https://www.google.com.br",
    },
    initialBenefits: "Tudo do plano Flex",
    moreBenefits: [
      "Usuários ilimitados",
      "Segmentações detalhadas (porte, setor, cargo)",
      "Exportação massiva e API ilimitada",
      "Créditos que não expiram",
      "Chat + e-mail com SLA de 6h",
      "Workshop de adoção para marketing e vendas",
    ],
    variant: "whiteButton",
  },
];

export const plansB2B: TPlanCard[] = [
  {
    title: "Grátis",
    isMostPopular: false,
    description:
      "Profissionais e equipes que desejam experimentar a plataforma sem risco",
    value: "0",
    creditsPerMonth: "50",
    findEnterprise: "1 empresa encontrada = 1 crédito",
    buttonProps: {
      text: "Começar agora",
      link: "https://www.google.com.br",
    },
    moreBenefits: [
      "1 usuário",
      "Consulta, Prospecção e Enriquecimento com 50 créditos válidos por 30 dias",
      "Tutoriais em vídeo e base de conhecimento completa",
      "Autoatendimento: tire dúvidas na base de conhecimento a qualquer hora",
      "Suporte por ticket liberado quando fizer upgrade",
    ],
    variant: "lightBlueButton",
  },
  {
    title: "Start",
    isMostPopular: false,
    description:
      "Pequenas empresas e autônomos que precisam de fluxo constante de leads",
    value: "299",
    creditsPerMonth: "500",
    findEnterprise: "1 empresa encontrada = 1 crédito",
    buttonProps: {
      text: "Começar agora",
      link: "https://www.google.com.br",
    },
    initialBenefits: "Tudo do plano Grátis",
    moreBenefits: [
      "1 usuário",
      "Funcionalidades essenciais de busca e exportação",
      "Chat em horário comercial (SLA de 12 h)",
      "Tutoriais guiados para começar em menos de 15 min",
    ],
    variant: "darkBlueButton",
  },
  {
    title: "Flex",
    isMostPopular: false,
    description: "Times comerciais em expansão que buscam escalar a prospecção",
    value: "627,90",
    creditsPerMonth: "2.000",
    findEnterprise: "1 empresa encontrada = 1 crédito",
    buttonProps: {
      text: "Começar agora",
      link: "https://www.google.com.br",
    },
    initialBenefits: "Tudo do plano Start",
    moreBenefits: [
      "Filtros avançados, exportação em lote",
      "Créditos válidos por 60 dias",
      "Chat + e-mail com SLA de 8h",
      "Sessão de onboarding ao vivo para a equipe",
    ],
    variant: "darkBlueButton",
  },
  {
    title: "Full",
    isMostPopular: true,
    description: "Departamentos de Vendas e Marketing de médio porte",
    value: "1.047,90",
    creditsPerMonth: "5.000",
    findEnterprise: "1 empresa encontrada = 1 crédito",
    buttonProps: {
      text: "Começar agora",
      link: "https://www.google.com.br",
    },
    initialBenefits: "Tudo do plano Flex",
    moreBenefits: [
      "Usuários ilimitados",
      "Segmentações detalhadas (porte, setor, cargo)",
      "Exportação massiva e API ilimitada",
      "Créditos que não expiram",
      "Chat + e-mail com SLA de 6h",
      "Workshop de adoção para marketing e vendas",
    ],
    variant: "whiteButton",
  },
];

export const planProps: TAllPlanProps = {
  B2C: {
    allRecurrenceCards: [
      {
        id: "monthly",
        text: "Mensal",
      },
      {
        id: "semester",
        discount: 15,
        text: "Semestral",
      },
      {
        id: "annual",
        discount: 25,
        text: "Anual",
      },
    ],
    allPlansPerRecurrence: {
      month: plansB2C,
    },
  },
  B2B: {
    allRecurrenceCards: [
      {
        id: "monthly",
        text: "Mensal",
      },
      {
        id: "semester",
        discount: 5,
        text: "Semestral",
      },
      {
        id: "annual",
        discount: 10,
        text: "Anual",
      },
    ],
    allPlansPerRecurrence: {
      month: plansB2B,
    },
  },
};
